import Joi from 'joi';
import PropTypes from 'prop-types';

import Button from '../../themed/button';
import Form from '../../common/form';

import * as constants from '../../../utils/constants';
import * as toastService from '../../../services/toastService';

class CustomUTMInspectionFormEditItem extends Form {
	state = {
		data: { sectionTitle: '', startColumn: '', endColumn: '', items: [] },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		sectionTitle: Joi.string().required().label('Section Title'),
		startColumn: Joi.string().required().label('Start Column'),
		endColumn: Joi.string().required().label('End Column'),
		items: Joi.array().min(0).required().label('UTM Inspection Items'),
	};

	static propTypes = {
		initialInspectionItem: PropTypes.object,
		onEdit: PropTypes.func,
		onCancelEdit: PropTypes.func,
	};

	componentDidMount(){
		if (!this.props.initialInspectionItem) {
			throw new Error('Please pass a default inspection item!');
		}



		this.setState({ data: this.props.initialInspectionItem });
	}

	doSubmit = (): void => {
		this.props.onEdit(this.state.data);
		toastService.success('Changes Saved Successfully!')
	};

	getEndAlphabetOptions = () => {
		const index = constants.ALPHABET_OPTIONS.findIndex((letter) => letter.id === this.state.data.startColumn);
		if (index !== -1) return constants.ALPHABET_OPTIONS.slice(index);

		return constants.ALPHABET_OPTIONS;
	}

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="container">
					{this.renderInput({
						type: 'text',
						name:'sectionTitle', 
						label:'Section Title / Name of UTM',
						placeholder:'Enter Section Title / Name of UTM e.g. TML e.g. TML',
					})} 

					<div className="row">
						<div className="col">
							{this.renderSelect({
								name:'startColumn', 
								options: constants.ALPHABET_OPTIONS,
								label:'Start Column',
								placeholder:'Select Start Column',
							})} 
						</div>

						<div className="col">
							{this.renderSelect({
								name:'endColumn', 
								options: this.getEndAlphabetOptions(),
								label:'End Column',
								placeholder:'Select End Column',
							})} 
						</div>
					</div>
				</div>

				<div className="divider mt-4"></div>

				<div className="d-flex justify-content-end align-items-center">
					{this.renderButton('Save Changes')}

					<div className="ms-4">
						<Button label='Cancel' onClick={this.props.onCancelEdit} style={{ backgroundColor: 'red' }} />
					</div>

				</div>
			</form>
		);
	}
}

export default CustomUTMInspectionFormEditItem;
